// extracted by mini-css-extract-plugin
export default {"nameField":"Contact_nameField__PnFBE","emailField":"Contact_emailField__4nEA7","textField":"Contact_textField__92yCh","backBtn":"Contact_backBtn__9Whyf"};